// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__390Nd","title":"AfterBackImages_title__M7kfA","images":"AfterBackImages_images__pWL0J"};